import { useParams, useSearchParams } from "react-router-dom";
import { normalizeReaderMode } from "../model/subjectSingleModel";

export function useSubjectSingleParams() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { subjectPublicId, gistPublicId } = useParams<{
    subjectPublicId?: string;
    gistPublicId?: string;
  }>();
  const subjectIdParam = searchParams.get("subjectId");
  const gistIdParam = searchParams.get("gistId");

  return {
    searchParams,
    setSearchParams,
    routeSubjectPublicId: subjectPublicId || null,
    routeGistPublicId: gistPublicId || null,
    subjectIdParam,
    gistIdParam,
    readerMode: normalizeReaderMode(searchParams.get("mode")),
    isGistExplorerView: searchParams.get("view") === "gists",
    selectedGistId: gistIdParam ? Number(gistIdParam) : NaN,
    initialSubjectId: subjectIdParam ? Number(subjectIdParam) : NaN,
  };
}
